// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Icon} from './../icon/Icon'

@Component({
    name: 'Link',
    components: {Icon},
    mixins: [
        template,
    ]
})
export class Link extends Vue {

    public get themeMap() {
        const themeMap = {
            default: 7,
            secondary: 6,
            inline: 9,
            inline_secondary: 8,
        }

        return themeMap[this.theme] ? themeMap[this.theme] : themeMap['default']
    }

    public get linkClasses() {

        const classes: string[] = []

        classes.push(`${this.$appPrefix}-link--${this.theme ? this.theme : 'default'}${this.icon ? '-with-icon' : ''}`)
        classes.push(`${this.$appPrefix}-link--${this.size}`)
        classes.push(`${this.$appPrefix}-link--icon-${this.iconSize}`)

        // !!! Special case for only right arrow icon !!!
        if (this.icon == this.$icons.ARROW_RIGHT) classes.push(`${this.$appPrefix}-link--arrow-right`)

        return classes
    }

    public get disabledClass() {
        return this.disabled ? `${this.$appPrefix}-link--disabled` : ''
    }

    @Prop([String, Object])
    public to!: any

    @Prop()
    public href!: string

    @Prop({default: false})
    public forceA!: boolean

    @Prop({default: 'default'})
    public theme!: string

    @Prop()
    public target!: string

    @Prop()
    public icon?: string

    @Prop()
    public iconFile?: string

    @Prop()
    public iconClass?: string

    @Prop({default: 'md'})
    public iconSize?: string

    @Prop({default: 'md'})
    public size?: string

    @Prop()
    public disabled?: boolean

    public created () {

    }
}